/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import classNames from 'classnames';
import { Control, Controller, RegisterOptions } from 'react-hook-form';
import styles from './Checkbox.module.scss';
import Icon from '../Icon/Icon';

export interface CheckboxProps {
  checked?: boolean;
  disabled?: boolean;
  indeterminate?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Checkbox: React.FC<CheckboxProps> = ({ checked, indeterminate = false, onChange, disabled }) => {
  return (
    <div
      className={classNames(styles.root, { [styles.indeterminate]: indeterminate, 'pointer-events-none': disabled })}>
      <label className={styles.container}>
        <input type="checkbox" checked={checked} onChange={onChange} disabled={disabled} />
        <span className={styles.checkmark}>{indeterminate ? <Icon name="minus" /> : <Icon name="checkmark" />}</span>
      </label>
    </div>
  );
};

export default Checkbox;

interface ControlledCheckboxProps extends Omit<CheckboxProps, 'checked' | 'onChange'> {
  control: Control<any>;
  name: string;
  rules?: RegisterOptions;
  defaultValue?: boolean;
}

export const ControlledCheckbox: React.FC<ControlledCheckboxProps> = ({
  control,
  name,
  rules,
  defaultValue = false,
  indeterminate,
  disabled,
}) => {
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field: { onChange, value } }) => (
        <Checkbox
          checked={value}
          onChange={e => onChange(e.target.checked)}
          indeterminate={indeterminate}
          disabled={disabled}
        />
      )}
    />
  );
};
